import "jspdf-autotable";

import {
  GetApprovalByPositionName,
  GetApprovalByPositionCode,
  fullNameTransform,
  valueTransform,
} from "../../util/ValueTransform";

import { dateSignature } from "../../util/DateSignature";
import jsPDF from "jspdf";
import kuLogo from "../../assets/image/logo/ku_logo.jpeg";
import qrCode from "../../assets/image/qrcode/form-example.jpg";
import sarabunFont from "../../assets/fonts/sarabun/THSarabunNew.ttf";
import sarabunFontMedium from "../../assets/fonts/sarabun/Sarabun-Medium.ttf";
import sarabunLight from "../../assets/fonts/sarabun/Sarabun-Light.ttf";
import sarabunRegular from "../../assets/fonts/sarabun/Sarabun-Regular.ttf";
import { thaiDate } from "../../util/DateObject";
import { thaitext } from "../../util/Thaitext";

export const Form1 = (props) => {
  console.log("props", props);
  const doc = new jsPDF({
    orientation: "p",
    format: "a4",
  });

  doc.addFont(sarabunFont, "Sarabun", "normal");
  doc.addFont(sarabunFontMedium, "Sarabun-Medium", "normal");
  doc.addFont(sarabunRegular, "Sarabun-Regular", "normal");
  doc.setFont("Sarabun-Medium");
  doc.setFontSize(15);
  doc.rect(5, 5, doc.internal.pageSize.width - 10, 25, "S");
  doc.addImage(kuLogo, "JPEG", 30, 8, 20, 20, 0, "NONE", 0);

  doc.text(
    "มหาวิทยาลัยเกษตรศาสตร์แบบลงทะเบียนเรียน (KU1)",
    doc.internal.pageSize.getWidth() / 2 + 5,
    15,
    { align: "center" }
  );

  doc.text(
    "KASETSART UNIVERSITY REGISTRATION FORM",
    doc.internal.pageSize.getWidth() / 2 + 5,
    23,
    { align: "center" }
  );

  doc.rect(5, 5, doc.internal.pageSize.width - 10, 35, "S");
  doc.setFont("Sarabun-Regular");
  doc.setFontSize(10);
  doc.text(
    "ภาค/SEMESTER_________________________ปีการศึกษา/ACADEMIC YEAR___________________วิทยาเขต/CAMPUS_______________________________________",
    10,
    36
  );

  thaitext(doc, valueTransform(props.DataUser?.Semester), 42, 36);

  thaitext(
    doc,
    valueTransform(props.DataUser?.SemesterYear.toString()),
    112,
    36
  );

  thaitext(doc, "บางเขน", 170, 36);

  doc.text("รหัสประจำตัวนิสิต/ID", 10, 47);
  doc.rect(43, 42, 6, 8, "S");
  doc.rect(49, 42, 6, 8, "S");
  doc.rect(55, 42, 6, 8, "S");
  doc.rect(61, 42, 6, 8, "S");
  doc.rect(67, 42, 6, 8, "S");
  doc.rect(73, 42, 6, 8, "S");
  doc.rect(79, 42, 6, 8, "S");
  doc.rect(85, 42, 6, 8, "S");
  doc.rect(91, 42, 6, 8, "S");
  doc.rect(97, 42, 6, 8, "S");

  thaitext(doc, valueTransform(props.DataUser?.Code[0]), 45, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[1]), 51, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[2]), 57, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[3]), 63, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[4]), 69, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[5]), 75, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[6]), 81, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[7]), 87, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[8]), 93, 47);
  thaitext(doc, valueTransform(props.DataUser?.Code[9]), 99, 47);

  thaitext(
    doc,
    "ชื่อนิสิต/STUDENT'S NAME_____________________________________________________________เบอร์โทรศัพท์/PHONE NUMBER______________________________",
    10,
    57
  );

  thaitext(doc, fullNameTransform(props), 55, 57);

  thaitext(doc, valueTransform(props.DataUser?.Phonenumber), 170, 57);

  doc.text(
    "คณะ/FACULTY______________ภาควิชา/DEPARTMENT______________________________________________รหัสสาขาวิชาเอก/MAJOR CODE_______________",
    10,
    65
  );

  thaitext(doc, valueTransform(props.DataUser?.Faculty), 35, 65);
  thaitext(doc, valueTransform(props.DataUser?.Department), 88, 65);
  thaitext(doc, valueTransform(props.DataUser?.MajorCode), 187, 65);

  thaitext(
    doc,
    "ชื่ออาจารย์ที่ปรึกษา/ADVISOR'S NAME____________________________________________รหัสอาจารย์ที่ปรึกษา/ADVISOR'S CODE________________________",
    10,
    74
  );

  thaitext(doc, fullNameTransform(props, "advisor"), 69, 74);

  thaitext(doc, valueTransform(props.DataUser?.ReportTo?.Code), 180, 74);

  doc.rect(5, 5, doc.internal.pageSize.width - 10, 74, "S");

  thaitext(doc, "รายวิชาที่ขอลงทะเบียนเรียน/LIST OF COURSES REGISTER", 5, 86);

  let testSubject = {
    form_credit: 0,
    form_subjectId: "",
    form_categories_lab: "",
    form_categories_lec: "",
    form_typeofRegister: "",
    form_nameofSubjectEn: "",
  };

  const subjectLength = 15 - props.Data?.form_subjects?.length;

  let subjectEmpty = Object.assign([], props.Data?.form_subjects);

  for (let index = 0; index < subjectLength; index++) {
    subjectEmpty.push(testSubject);
  }

  const subjectDetail = subjectEmpty.map((x, i) => {
    const result = [
      {
        content: i + 1,
      },
      {
        content: x.form_subjectId[0] ?? "  ",
      },
      {
        content: x.form_subjectId[1] ?? "  ",
      },
      {
        content: x.form_subjectId[2] ?? "  ",
      },
      {
        content: x.form_subjectId[3] ?? "  ",
      },
      {
        content: x.form_subjectId[4] ?? "  ",
      },
      {
        content: x.form_subjectId[5] ?? "  ",
      },
      {
        content: x.form_subjectId[6] ?? "  ",
      },
      {
        content: x.form_subjectId[7] ?? "  ",
      },
      {
        content: x.form_typeofRegister ?? "  ",
      },
      {
        content: x.form_categories_lec ?? "  ",
      },
      {
        content: x.form_categories_lab ?? "  ",
      },
      {
        content: x.form_nameofSubjectEn ?? "  ",
      },
      {
        content: x.form_credit === 0 ? " " : x.form_credit,
      },
    ];
    return result;
  });

  console.log("subjectDetail", subjectDetail);

  doc.autoTable({
    margin: { left: 5, top: 90, right: 5, bottom: 0 },
    styles: { font: "Sarabun-Regular", fontSize: 8 },
    didDrawCell: function (data) {
      if (data.column.index === 14 && data.cell.section === "body") {
        var textPos = data.cell;
        if (data.row.raw[12]) {
          const step = props.ApprovalStep.filter(
            (x) => x.ForDev && x.ForDev.SubjectName === data.row.raw[12].content
          )[0];
          doc.addImage(
            valueTransform(step?.SignatureImage),
            "JPEG",
            textPos.x + 2,
            textPos.y + 1,
            valueTransform(step?.SignatureDimension?.width),
            5,
            `surenagix-${data.column.index}-${data.row.index}`,
            "NONE",
            0
          );
        }
      }
    },
    headerStyles: {
      lineWidth: 0.2,
      lineColor: [0, 0, 0],
      fillColor: "#ffffff",
      textColor: "#000000",
    },
    columnStyles: {
      0: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      1: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      2: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      3: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      4: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      5: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      6: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      7: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      8: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      9: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      10: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      11: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      12: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      13: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
      14: { halign: "center", valign: "middle", fillColor: [255, 255, 255] },
    },
    bodyStyles: {
      lineWidth: 0.2,
      lineColor: [0, 0, 0],
      fillColor: "#ffffff",
      textColor: "#000000",
    },

    head: [
      [
        {
          content: "ลำดับ\nNO.",
          styles: { halign: "center", valign: "middle" },
          rowSpan: 2,
        },
        {
          content: "รหัสวิชา\nCOURSE CODE",
          styles: { halign: "center", valign: "middle" },
          rowSpan: 2,
          colSpan: 8,
        },
        {
          content: "ประเภทการ\nลงทะเบียน\nTYPE OF\nREGIS.",
          styles: { halign: "center", valign: "middle" },
          rowSpan: 2,
        },
        {
          content: "หมู่เรียน/SECTION",
          styles: { halign: "center", valign: "middle" },
          colSpan: 2,
        },
        {
          content: "ชื่อวิชา(เขียนเป็นภาษาอังกฤษ)/COURSE TITLE",
          styles: { halign: "center", valign: "middle" },
          rowSpan: 2,
        },
        {
          content: "หน่วยกิต\nCREDITS",
          styles: { halign: "center", valign: "middle" },
          rowSpan: 2,
        },
        {
          content: "ลงนามอาจารย์\nประจำวิชา\nINSTRUCTURE's\nSIGNATURE",
          styles: { halign: "center", valign: "middle" },
          rowSpan: 2,
        },
      ],
      [
        {
          content: "บรรยาย\nLECTURE",
          styles: { halign: "center", valign: "middle" },
        },
        {
          content: "ปฏิบัติการ\nLAB",
          styles: { halign: "center", valign: "middle" },
        },
      ],
    ],
    body: subjectDetail,
  });
  doc.setFontSize(8);
  thaitext(doc, "่", 111.2, 99);
  doc.setFontSize(10);
  doc.text(
    "ลงนามนิสิต/STUDENT'S SIGNATURE_________________________________________ลงนามอาจารย์/ADVISOR'S SIGNATURE____________________________________",
    5,
    280
  );

  doc.addImage(
    valueTransform(props.ApprovalStep[0]?.SignatureImage),
    "JPEG",
    70,
    275,
    valueTransform(props.ApprovalStep[0]?.SignatureDimension?.width),
    5,
    "signature",
    "NONE",
    0
  );

  doc.addImage(
    valueTransform(
      GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.SignatureImage
    ),
    "JPEG",
    175,
    275,
    valueTransform(
      GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.SignatureDimension
        ?.width
    ),
    5,
    "signature-teacher",
    "NONE",
    0
  );

  thaitext(
    doc,
    "วันที่/DATE_________________________________________",
    43,
    290
  );
  thaitext(doc, "วันที่/DATE____________________________________", 147, 290);
  thaitext(
    doc,
    dateSignature(
      GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.DatetimeUpdated
    ),
    165,
    289
  );

  thaitext(
    doc,
    dateSignature(
      props.ApprovalStep[0]?.DatetimeUpdated
        ? props.ApprovalStep[0]?.DatetimeUpdated
        : props.ApprovalStep[0]?.DatetimeCreated
    ),
    67,
    289
  );

  //page 2

  // doc.addPage();

  // doc.addFont(sarabunFont, "Sarabun", "normal");
  // doc.addFont(sarabunFontMedium, "Sarabun-Medium", "normal");
  // doc.addFont(sarabunRegular, "Sarabun-Regular", "normal");
  // doc.addFont(sarabunLight, "Sarabun-Light", "normal");
  // doc.setFont("Sarabun-Medium");
  // doc.setFontSize(15);
  // doc.addImage(
  //   kuLogo,
  //   "JPEG",
  //   doc.internal.pageSize.getWidth() / 2 - 12,
  //   5,
  //   25,
  //   25,
  //   0,
  //   "NONE",
  //   0
  // );
  // doc.text(
  //   "มหาวิทยาลัยเกษตรศาสตร์",
  //   doc.internal.pageSize.getWidth() / 2 - 25,
  //   40
  // );
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(12);
  // thaitext(doc, "คำร้องทั่วไป", doc.internal.pageSize.getWidth() / 2 - 10, 47);

  // //Righr QRcode
  // doc.addImage(
  //   qrCode,
  //   "JPEG",
  //   doc.internal.pageSize.getWidth() / 2 + 70,
  //   5,
  //   30,
  //   30,
  //   "qrCode",
  //   "NONE",
  //   0
  // );
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(
  //   doc,
  //   "ตัวอย่างการเขียนคำร้อง",
  //   doc.internal.pageSize.getWidth() / 2 + 70,
  //   40
  // );
  // //End Right QRcode

  // // Contect
  // doc.setFontSize(10);
  // thaitext(
  //   doc,
  //   `วันที่.............เดือน....................................พ.ศ................`,
  //   doc.internal.pageSize.getWidth() / 2 - 35,
  //   54
  // );
  // thaitext(
  //   doc,
  //   thaiDate(props.DatetimeCreated).day,
  //   doc.internal.pageSize.getWidth() / 2 - 25,
  //   53
  // );
  // thaitext(
  //   doc,
  //   thaiDate(props.DatetimeCreated).month,
  //   doc.internal.pageSize.getWidth() / 2,
  //   53
  // );
  // thaitext(doc, thaiDate(props.DatetimeCreated).year, 137, 53);
  // thaitext(
  //   doc,
  //   `เรื่อง.................................................................................`,
  //   10,
  //   65
  // );
  // thaitext(doc, valueTransform(props.Data.form_topic), 20, 64);
  // thaitext(
  //   doc,
  //   "เรียน.................................................................................",
  //   10,
  //   73
  // );
  // thaitext(
  //   doc,
  //   valueTransform(
  //     `${props.DataUser.ReportTo.FirstnameTh} ${props.DataUser.ReportTo.LastnameTh}`
  //   ),
  //   20,
  //   72
  // );
  // doc.setFontSize(9);
  // doc.setFont("Sarabun-Light");
  // thaitext(doc, "(อาจารย์ที่ปรึกษา)", 25, 78);

  // doc.setFontSize(10);
  // doc.setFont("Sarabun-Regular");
  // thaitext(
  //   doc,
  //   "ข้าพเจ้า  นาย/นาง/นางสาว..................................................................................เลขประจำตัว.................................. นิสิตปีที่ .............",
  //   20,
  //   85
  // );
  // thaitext(
  //   doc,
  //   ` ${valueTransform(props.DataUser.FirstnameTh)}   ${valueTransform(
  //     props.DataUser.LastnameTh
  //   )}`,
  //   65,
  //   84
  // );

  // thaitext(doc, ` ${valueTransform(props.DataUser.Code)}`, 155, 84);

  // thaitext(doc, ` ${valueTransform(props.DataUser.AcademicYear)}`, 195, 84);

  // thaitext(
  //   doc,
  //   "สาขาวิชาเอก.................................................................................................คณะ..............................................................................................",
  //   10,
  //   92
  // );

  // thaitext(doc, valueTransform(props.DataUser.Department), 35, 91);
  // thaitext(doc, valueTransform(props.DataUser.Faculty), 125, 91);

  // thaitext(
  //   doc,
  //   "ที่อยู่ปัจจุบัน........................................................................................................................................................................................................",
  //   10,
  //   99
  // );

  // thaitext(
  //   doc,
  //   valueTransform(props.DataUser.CurrentAddress.HomeNo) +
  //   " " +
  //   valueTransform(props.DataUser.CurrentAddress.Soi) +
  //   " " +
  //   valueTransform(props.DataUser.CurrentAddress.VillageNo) +
  //   " " +
  //   valueTransform(props.DataUser.CurrentAddress.City) +
  //   " " +
  //   valueTransform(props.DataUser.CurrentAddress.Province) +
  //   " " +
  //   valueTransform(props.DataUser.CurrentAddress.Country) +
  //   " " +
  //   valueTransform(props.DataUser.CurrentAddress.Zipcode),
  //   35,
  //   98
  // );

  // thaitext(
  //   doc,
  //   "โทรศัพท์........................................................................................E-mail..........................................................................................................",
  //   10,
  //   106
  // );

  // thaitext(doc, valueTransform(props.DataUser.Phonenumber), 30, 105);
  // thaitext(doc, valueTransform(props.DataUser.Email), 120, 105);

  // thaitext(doc, "ความประสงค์ (ระบุความประสงค์และเหตุผล)", 10, 113);
  // thaitext(doc, valueTransform(props.Data.form_reason), 15, 119);

  // thaitext(
  //   doc,
  //   "...........................................................................................................................................................................................................................",
  //   10,
  //   120
  // );

  // thaitext(
  //   doc,
  //   "...........................................................................................................................................................................................................................",
  //   10,
  //   127
  // );

  // thaitext(
  //   doc,
  //   "...........................................................................................................................................................................................................................",
  //   10,
  //   134
  // );

  // thaitext(doc, "จึงเรียนมาเพื่อโปรดพิจารณา", 150, 141);
  // thaitext(
  //   doc,
  //   "ลงนาม....................................................",
  //   140,
  //   148
  // );
  // thaitext(doc, "(                                           )", 150, 155);

  // doc.addImage(
  //   valueTransform(props.ApprovalStep[0]?.SignatureImage),
  //   "JPEG",
  //   165,
  //   142,
  //   valueTransform(props.ApprovalStep[0]?.SignatureDimension?.width),
  //   5,
  //   "signature",
  //   "NONE",
  //   0
  // );

  // thaitext(
  //   doc,
  //   valueTransform(props.DataUser.FirstnameTh) +
  //   " " +
  //   valueTransform(props.DataUser.LastnameTh),
  //   152,
  //   155
  // );
  // doc.setFont("Sarabun-Light");
  // doc.rect(10, 161, 95.25, 43);
  // doc.rect(105.25, 161, 95.25, 43);
  // doc.rect(10, 204, 95.25, 43);
  // doc.rect(105.25, 204, 95.25, 43);

  // // Start box 1
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(doc, "1. เรียน หัวหน้าภาคฯ / ประธานบริหารหลักสูตร", 15, 166);

  // thaitext(
  //   doc,
  //   valueTransform(
  //     GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.Comment
  //   ),
  //   20,
  //   175
  // );
  // thaitext(
  //   doc,
  //   "...................................................................................",
  //   20,
  //   176,
  // );
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(
  //   doc,
  //   "ลงนาม/Signature...........................................................",
  //   30,
  //   187
  // );
  // doc.addImage(
  //   valueTransform(
  //     GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.SignatureImage
  //   ),
  //   "JPEG",
  //   71,
  //   181,
  //   valueTransform(
  //     GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.SignatureDimension
  //       ?.width
  //   ),
  //   5,
  //   "signature-step-1",
  //   "NONE",
  //   0
  // );
  // thaitext(doc, "(.................................................)", 55, 192);

  // thaitext(doc, fullNameTransform(props, "advisor"), 63, 191);
  // thaitext(doc, "........./.........../............", 65, 197);

  // thaitext(doc, "อาจารย์ที่ปรึกษา", 65, 202);
  // thaitext(
  //   doc,
  //   dateSignature(
  //     GetApprovalByPositionName(props, "อาจารย์ที่ปรึกษา")?.DatetimeUpdated
  //   ),
  //   65,
  //   196
  // );
  // // End Box 1

  // // Start Box 2
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(doc, "2. เรียน คณบดี", 15, 209);
  // thaitext(
  //   doc,
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "chiefSyllabus")
  //       ?.Comment
  //   ),
  //   20,
  //   218
  // );
  // thaitext(
  //   doc,
  //   "...................................................................................",
  //   20,
  //   219,
  // );
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(
  //   doc,
  //   "ลงนาม/Signature...........................................................",
  //   30,
  //   230
  // );
  // doc.addImage(
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "chiefSyllabus")
  //       ?.SignatureImage
  //   ),
  //   "JPEG",
  //   70,
  //   225,
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "chiefSyllabus")
  //       ?.SignatureDimension?.width
  //   ),
  //   5,
  //   "signature-step-2",
  //   "NONE",
  //   0
  // );
  // thaitext(doc, "(.................................................)", 55, 235);
  // thaitext(
  //   doc,
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "chiefSyllabus")
  //       ?.ForDev?.Major?.Chief
  //   ),
  //   58,
  //   234
  // );
  // thaitext(doc, "........./.........../............", 65, 240);

  // thaitext(
  //   doc,
  //   dateSignature(
  //     GetApprovalByPositionCode(props, "chiefSyllabus")
  //       ?.DatetimeUpdated
  //   ),
  //   65,
  //   239
  // );
  // thaitext(doc, "หัวหน้าภาคฯ / ประธานบริหาร", 52, 245);
  // // End Box 2

  // // Start Box 3
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(doc, "3. เรียน คณบดี", 110, 166);
  // thaitext(
  //   doc,
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "studyOfficer")?.Comment
  //   ),
  //   115,
  //   175
  // );
  // thaitext(
  //   doc,
  //   "...................................................................................",
  //   115,
  //   176,
  // );

  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(
  //   doc,
  //   "ลงนาม/Signature...........................................................",
  //   125,
  //   187
  // );
  // doc.addImage(
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "studyOfficer")
  //       ?.SignatureImage
  //   ),
  //   "JPEG",
  //   170,
  //   181,
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "studyOfficer")
  //       ?.SignatureDimension?.width
  //   ),
  //   5,
  //   "signature-step-3",
  //   "NONE",
  //   0
  // );
  // thaitext(
  //   doc,
  //   "(.................................................)",
  //   150,
  //   192
  // );
  // thaitext(
  //   doc,
  //   valueTransform(
  //     GetApprovalByPositionCode(props, "studyOfficer")
  //       ?.ForDev?.ApprovedBy
  //   ),
  //   155,
  //   191
  // );
  // thaitext(doc, "........./.........../............", 158, 197);
  // thaitext(
  //   doc,
  //   dateSignature(
  //     GetApprovalByPositionCode(props, "studyOfficer")
  //       ?.DatetimeUpdated
  //   ),
  //   158,
  //   196
  // );
  // thaitext(doc, "studyOfficer", 155, 202);
  // // End Box 3

  // // Start Box 4
  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(doc, `4. ${valueTransform(GetApprovalByPositionName(props, "คณบดี")?.ForDev?.AgendaForDean)}`, 110, 209);
  // thaitext(
  //   doc,
  //   valueTransform(GetApprovalByPositionName(props, "คณบดี")?.Comment),
  //   115,
  //   218
  // );

  // thaitext(
  //   doc,
  //   "...................................................................................",
  //   115,
  //   219,
  // );
  // doc.setFont("Sarabun-Light");

  // doc.setFont("Sarabun-Regular");
  // doc.setFontSize(9);
  // thaitext(
  //   doc,
  //   "ลงนาม/Signature...........................................................",
  //   125,
  //   230
  // );
  // doc.addImage(
  //   valueTransform(GetApprovalByPositionName(props, "คณบดี")?.SignatureImage),
  //   "JPEG",
  //   168,
  //   225,
  //   valueTransform(
  //     GetApprovalByPositionName(props, "คณบดี")?.SignatureDimension?.width
  //   ),
  //   5,
  //   "signature-step-4",
  //   "NONE",
  //   0
  // );
  // thaitext(
  //   doc,
  //   "(.................................................)",
  //   150,
  //   235
  // );
  // thaitext(
  //   doc,
  //   valueTransform(
  //     GetApprovalByPositionName(props, "คณบดี")?.ApprovalTemplate?.FullName
  //   ),
  //   154,
  //   234
  // );
  // thaitext(doc, "........./.........../............", 160, 240);
  // thaitext(
  //   doc,
  //   dateSignature(GetApprovalByPositionName(props, "คณบดี")?.DatetimeUpdated),
  //   160,
  //   239
  // );
  // thaitext(doc, "คณบดี", 168, 245);

  doc.output("dataurlnewwindow");
  // doc.save("form1.pdf");
};
